module.exports = __webpack_public_path__ + "static/media/arti.5d4ca1ba.jpg";